/**
 * FunnelBanner
 *
 * Inline banner for collection page funnel experiences.
 * Converted from Emotion styled-components to Tailwind CSS.
 */

import type { FunnelOffer } from '../funnel-runtime.types'

interface FunnelBannerProps {
  offer: FunnelOffer
  onAccept: () => void
  onDecline: () => void
  onDismiss: () => void
  accepting?: boolean
}

export function FunnelBanner({ offer, onAccept, onDecline, onDismiss, accepting }: FunnelBannerProps) {
  return (
    <div className="relative mb-6 flex items-center justify-between gap-4 overflow-hidden rounded-xl bg-gradient-to-br from-indigo-600 to-purple-600 px-6 py-5 animate-funnel-banner-slide-in max-sm:flex-col max-sm:text-center">
      {/* Content */}
      <div className="min-w-0 flex-1">
        <h3 className="mb-1 text-lg font-bold text-white">
          {offer.headline}
        </h3>
        <p className="m-0 text-sm text-white/85">
          <strong>${offer.pricingValue.toFixed(2)}</strong>
          {' '}
          <span className="line-through opacity-70">
            ${offer.originalPrice.toFixed(2)}
          </span>
        </p>
      </div>

      {/* Actions */}
      <div className="flex shrink-0 items-center gap-3">
        <button
          className="whitespace-nowrap rounded-lg bg-white px-5 py-2.5 text-sm font-bold text-indigo-600 transition-opacity hover:opacity-90 disabled:opacity-60"
          onClick={onAccept}
          disabled={accepting}
        >
          {accepting ? 'Adding...' : offer.ctaText}
        </button>
        <button
          className="whitespace-nowrap border-none bg-transparent text-[13px] text-white/85 underline cursor-pointer hover:text-white"
          onClick={onDecline}
        >
          {offer.declineText}
        </button>
        <button
          className="border-none bg-transparent p-1 text-lg leading-none text-white/70 cursor-pointer hover:text-white"
          onClick={onDismiss}
          aria-label="Dismiss"
        >
          &times;
        </button>
      </div>
    </div>
  )
}
